<template>
  <div>
    <h3 class="modal-title"> TIMESHEET </h3>
    <b-form-group :class="{'error-input' : $v.data_timesheet.title.$error}">
      <label> Timesheet Title </label>
      <j-input
        v-model="$v.data_timesheet.title.$model"
        :max-length="255"
        placeholder="Timesheet Title"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeTimesheet">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveTimesheet">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_timesheet: {
      title: {
        required,
      },
    },
  },
  data() {
    return {
      data_timesheet: {
        title: '',
      },
    };
  },
  computed: {
    generateDataTimesheet() {
      const infoName = this.data_timesheet.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_timesheet.title,
        widget_master_id: this.dataMaster.id,

        type: 2,
        position: this.dataMaster.position,
      };
      return data;
    },

    generateDataTimesheetUpdate() {
      const infoName = this.data_timesheet.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_timesheet.title,
        widget_master_id: this.dataMaster.id,

        type: 2,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_timesheet.title = JSON.parse(this.dataEdit.info).name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),

    saveTimesheet() {
      this.$v.data_timesheet.$touch();
      if (!this.$v.data_timesheet.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateDataTimesheet;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataTimesheetUpdate;
          this.updateWidget({ widgetId, dataParam });
        }
        this.closeTimesheet();
      }
    },

    closeTimesheet() {
      this.$emit('close-field');
      this.data_timesheet.title = null;
      setTimeout(() => {
        this.$v.data_timesheet.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jTimesheetSetup.vue